export default e => e.stopPropagation()
